import axios from "axios";

function measurementsSearch(objAux) {
	return new Promise((resolve, reject) => {
		try {
			let port = ""
			if (process.env.ROOT_API.includes("viewmedonline"))
				port = ":3069"
			axios.get(process.env.ROOT_API  + "/measurements/query/" + objAux.id, {
				headers: {
					'Authorization': objAux.token
				}
			}).then(result => {
				resolve(result.data.documents)
			}).catch((error) => {
				reject(error.response.data.message)
			})
		} catch (error) {
			console.log('measurementsSearch: ', error)
		}
	})
}
function measurementsSearchList(objAux) {
	return new Promise((resolve, reject) => {
		try {
			let port = ""
			if (process.env.ROOT_API.includes("viewmedonline"))
				port = ":3087"
			axios.post(process.env.ROOT_API  + "/measurements/list", objAux, {
				headers: {
					'Authorization': objAux.token
				}
			}).then(result => {
				resolve(result.data.documents)
			}).catch((error) => {
				reject(error.response.data.message)
			})
		} catch (error) {
			console.log('measurementsSearch: ', error)
		}
	})
}
function measurementsUpdate(objAux) {

	return new Promise((resolve, reject) => {
		try {
			let port = ""
			let url = process.env.ROOT_API  + "/measurements/update/";
			if (process.env.ROOT_API.includes("viewmedonline"))
				port = ":3073"
				if(objAux.id_medida){
					url = url + objAux.id_medida
				}
			axios.put(url,
				objAux.body, {
					headers: {
						Authorization: objAux.token
					}
				}).then(result => {
					resolve(result)
				}).catch(error => {

					reject(error.response.data.message)
				})
		} catch (error) {
			console.log('measurementsUpdate: ', error)
		}
	})
}
function measurementsInsert(objAux) {
	return new Promise((resolve, reject) => {
		try {
			let port = ""
			if (process.env.ROOT_API.includes("viewmedonline"))
				port = ":3068"
			axios.post(process.env.ROOT_API  + "/measurements/insert",
				objAux.body,
				{
					headers: {
						'Authorization': objAux.token
					}
				}).then(result => {
					resolve(result.data.documents[0])
				}).catch(error => {

					reject(error.response.data.message)
				})
		} catch (error) {
			console.log('measurementsInsert: ', error)
		}
	})
}

function measurementsDelete(objAux) {

	return new Promise((resolve, reject) => {
		try {
			let port = ""
			if (process.env.ROOT_API.includes("viewmedonline"))
				port = ":3086"
			axios.delete(process.env.ROOT_API  + "/measurements/delete",
				{
					data: objAux.body,
					headers: {
						'Authorization': objAux.token
					}
				})
				.then(result => {
					resolve(result)

				}).catch(error => {
					reject(error)
				})
		} catch (err) {
			console.log('measurementsDelete: ', err);

		}
	})
}

function measurementsType(objAux) {
	return new Promise((resolve, reject) => {
		try {
			let port = ""
			if (process.env.ROOT_API.includes("viewmedonline"))
				port = ":3097"
			axios.get(process.env.ROOT_API  + "/measurements/types", {
				headers: {
					'Authorization': objAux.token
				}
			})
				.then(result => {
					resolve(result.data.documents)
				}).catch(error => {
					reject(error)
				})
		} catch (err) {
			console.log('measurementsType: ', err);

		}
	})
}
export {
	measurementsSearch,
	measurementsUpdate,
	measurementsInsert,
	measurementsDelete,
	measurementsType,
	measurementsSearchList
};



// WEBPACK FOOTER //
// ./src/components/measurements/measurementsSev.js